export default {
  messageType: '와이드 아이템리스트',
  itemListSetting: '아이템 설정',
  title: '와이드 아이템리스트 설정',
  label: {
    mainTitle: '제목',
    content: [
      '내용',
      '내용',
      '내용',
      '내용',
    ],
    image: [
      '이미지 첨부',
      '이미지 첨부',
      '이미지 첨부',
      '이미지 첨부',
    ],
    imageDescription: [
      '리스트 이미지는 400x400 (1:1) ~ 800x400 (2:1)를 권장합니다.',
      '리스트 이미지는 400x400 (1:1) ~ 800x400 (2:1)를 권장합니다.',
      '리스트 이미지는 400x400 (1:1) ~ 800x400 (2:1)를 권장합니다.',
      '리스트 이미지는 400x400 (1:1) ~ 800x400 (2:1)를 권장합니다.',
    ],
    mobileLink: [
      '모바일 웹 링크',
      '모바일 웹 링크',
      '모바일 웹 링크',
      '모바일 웹 링크',
    ],
    pcLink: [
      'PC 웹 링크',
      'PC 웹 링크',
      'PC 웹 링크',
      'PC 웹 링크',
    ],
    iosDeepLink: [
      'iOS 앱 링크',
      'iOS 앱 링크',
      'iOS 앱 링크',
      'iOS 앱 링크',
    ],
    androidDeepLink: [
      '앱 링크',
      '앱 링크',
      '앱 링크',
      '앱 링크',
    ],
  },
  alt: {
    image: '와이드아이템리스트 이미지',
  },
  validation: {
    list: {
      max: '와이드아이템리스트 형의 아이템은 최대 4개 까지만 설정 가능합니다.',
    },
  },
};
